import { pipelineNotificationApi } from '@/modules/pipelines/api';
import { EntityNode } from '@/modules/pipelines/model/pipeline-alerts/entity-node';
import { PipelineEventType } from '@/modules/pipelines/model/pipeline-alerts/pipeline-event-type';
import React, { createContext, useEffect, useState } from 'react';

export interface PipelineFilters {
  operator?: string[];
  isCritical?: boolean;
  planningStatus?: string[];
  eventStatus?: string[];
  eventTypeClassification?: string[];
  event?: string[];
  postedBetween?: {
    start?: Date;
    end?: Date;
  };
}

export interface PipelineNotificationContextType {
  // operators: PipelineOperator[];
  // setOperators: (s: PipelineOperator[]) => void;
  events: PipelineEventType[];
  setEvents: (s: PipelineEventType[]) => void;
  eventStatuses: string[];
  setEventStatuses: (s: string[]) => void;
  planningStatuses: string[];
  setPlanningStatuses: (s: string[]) => void;
  entities: EntityNode[];
  setEntities: (s: EntityNode[]) => void;
  //selectedView: ViewType;
  //setSelectedView: (s: ViewType) => void;
  filters: PipelineFilters;
  setFilters: React.Dispatch<React.SetStateAction<PipelineFilters>>;
}

export const PipelineNotificationContext = createContext<PipelineNotificationContextType>({
  // operators: [],
  // setOperators: s => {},
  events: [],
  setEvents: s => {},
  entities: [],
  setEntities: s => {},
  eventStatuses: [],
  setEventStatuses: s => {},
  planningStatuses: [],
  setPlanningStatuses: s => {},
  //selectedView: 'notification',
  //setSelectedView: s => {},
  filters: {},
  setFilters: s => {},
});

export function PipelineNotificationContextProvider({ children }: React.PropsWithChildren<{}>) {
  // const [operators, setOperators] = useState<PipelineOperator[]>([]);
  const [events, setEvents] = useState<PipelineEventType[]>([]);
  const [entities, setEntities] = useState<EntityNode[]>([]);
  const [eventStatuses, setEventStatuses] = useState<string[]>([]);
  const [planningStatuses, setPlanningStatuses] = useState<string[]>([]);
  // const [selectedView, setSelectedView] = useState<ViewType>(
  //   (localStorage.getItem('p-selected-view') as ViewType) || 'notification',
  // );

  const [filters, setFilters] = useState<PipelineFilters>(() => {
    const storedFilters = localStorage.getItem('p-search-filters');
    return storedFilters ? (JSON.parse(storedFilters) as PipelineFilters) : {};
  });

  // useEffect(() => {
  //   pipelineNotificationApi.getPipelineOperators().then(value => {
  //     setOperators(value.content);
  //   });
  // }, [setOperators]);

  useEffect(() => {
    pipelineNotificationApi.getPipelineEntities(['REGION', 'PIPELINE']).then(value => {
      setEntities(value.content);
    });
  }, [setEntities]);

  useEffect(() => {
    pipelineNotificationApi.getPipelineEventTypes().then(value => {
      setEvents(value.content);
    });
  }, [setEvents]);

  useEffect(() => {
    pipelineNotificationApi.getPlanningStatuses().then(value => {
      setPlanningStatuses(value.content.map(c => c._id));
    });
  }, [setEvents]);

  useEffect(() => {
    pipelineNotificationApi.getEventStatuses().then(value => {
      setEventStatuses(value.content.map(c => c._id));
    });
  }, [setEvents]);

  useEffect(() => {
    if (filters) localStorage.setItem('p-search-filters', JSON.stringify(filters));
  }, [filters]);

  return (
    <PipelineNotificationContext.Provider
      value={{
        // operators,
        // setOperators,
        events,
        setEvents,
        entities,
        setEntities,
        eventStatuses,
        setEventStatuses,
        planningStatuses,
        setPlanningStatuses,
        // selectedView,
        // setSelectedView,
        filters,
        setFilters,
      }}
    >
      {children}
    </PipelineNotificationContext.Provider>
  );
}
